var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "3ad30d35964afd7968bf9f98763c1d66bab7fa8c"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["icloudready-newwebsite@icloudready"] = {
  id: "3ad30d35964afd7968bf9f98763c1d66bab7fa8c"
};